<template>
  <div class="diceContainer">
    <div class="row" :class="{ shakeX: disabled }">
      
      <span id="damagespan">Total Damage: {{ totalDamage }}</span>
      <button id="reset" 
              class="reload button"
              @click="resetDice(); shakeX();"
              >
              <i class="fa-solid fa-rotate-right"></i>
      </button>
    </div>
    <div id="dice" class="row">
      <button 
        :class="{ shaked4: shaked4 }"
        id="d4"           
        ref="4" 
        class="shake-button button col-sm-12 col-md-12" 
        @click="evaluate(4); shakeD4();">d4 {{ d4 }}
      </button>
      <button 
        :class="{ shaked6: shaked6 }"
        id="d6"           
        ref="6"   
        class="shake-button button col-sm-12 col-md-12"                               
        @click="evaluate(6); shakeD6();">d6 {{ d6 }}
      </button>
      <button 
        :class="{ shaked8: shaked8 }"
        id="d8"           
        ref="8"   
        class="shake-button button col-sm-12 col-md-12"                               
        @click="evaluate(8); shakeD8();">d8 {{ d8 }}
      </button>
      <button 
        :class="{ shaked10: shaked10 }"
        id="d10"          
        ref="10"  
        class="shake-button button col-sm-12 col-md-12"                               
        @click="evaluate(10); shakeD10();">d10 {{ d10 }}
      </button>
    </div>
    <!-- 
      https://codepen.io/aut0maat10/pen/ExaNZNo
     -->
  </div>
</template>
<script>
  // import gsap from 'gsap';
  import DM from '../views/DM.vue';
  export default {
    components: DM,
    name: 'Dice',
    data: function () {
      return {
        totalDamage: 0,
        d4: '',
        d6: '',
        d8: '',
        d10: '',
        altText: 'click me',
        animated: false,
        disabled: false,
        shaked4: false,
        shaked6: false,
        shaked8: false,
        shaked10: false,
        x: 0,
      }
    },
    props: ['text'],
    methods: {
      // evaluates if value passed is a number or not
      evaluate: function (val) {
        if (!isNaN(val)) {
          this.roll(val);
        } else {
          if (val == 'dst') {
            this.rollDST();
          } else {
            this.rollADV(val);
          }
        }
      },
      // rolls d4, d6, d8, d10, d12 and adds to total
      // if value is 20 or 100 => do not add to total
      roll: function (val) {
        let randomize = (Math.floor(Math.random() * val)) + 1;
        if (val < 10 ) {
          // add to totalDamage
          this.totalDamage += randomize;
        }
        switch(val) {
          case 4:
            this.d4 = '= '    + randomize;
            break;
          case 6:
            this.d6 = '= '    + randomize;
            break;
          case 8:
            this.d8 = '= '    + randomize;
            break;
          case 10:
            this.d10 = '= '   + randomize;
            break;
        }
        console.log(randomize);
      },
      resetDice: function () {
        this.totalDamage  = 0,
        this.d4           = '';
        this.d6           = '';
        this.d8           = '';
        this.d10          = '';
      },
      onMousemove(e) {
        this.x = e.clientX
      },
      // https://stackoverflow.com/questions/71306745/shake-effect-in-vue
      // shake x-axis
      shakeX() {
        this.disabled = true
        setTimeout(() => {
          this.disabled = false
        }, 1500)
      },
      shakeD4() {
        this.shaked4 = true
        setTimeout(() => {
          this.shaked4 = false
        }, 500)
      },
      shakeD6() {
        this.shaked6 = true
        setTimeout(() => {
          this.shaked6 = false
        }, 750)
      },
      shakeD8() {
        this.shaked8 = true
        setTimeout(() => {
          this.shaked8 = false
        }, 1000)
      },
      shakeD10() {
        this.shaked10 = true
        setTimeout(() => {
          this.shaked10 = false
        }, 1000)
      },
    },
  }
</script>
<style lang="scss" scoped>
#reset {
  color: white;
  background-color: #2d2653;
  font-weight: bolder;
  width: 30%;
  grid-area: 1 / 1 / 1 / span 3;
}
#damagespan {
  color: white;
  font-weight: bolder;
  background-color: #2d2653;
  border-radius: 15px;
  margin-bottom: 10px;
  // color: black;
  padding: 15px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  width: 60%;
  margin-right: 10%;
  grid-area: 1 / 2 / span 1 / span 3; 
}
#d4, #d6, #d8, #d10 { 
  background-color: #080808;
  border: solid 2px #2d2653;
}
// https://stackoverflow.com/questions/71800155/vue-3-how-to-change-body-background-color-only-in-specific-page
// .otherColor {
//   background-color: #140d36;
// }
.shakeX {
  animation: shakeX 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
}
.shaked4 {
  animation: shaked4 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
}
.shaked6 {
  animation: shaked6 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
}
.shaked8 {
  animation: shaked8 0.82s cubic-bezier(.6,.07,.4,.8) both;
  transform: translate3d(0, 0, 0);
}
.shaked10 {
  animation: shaked10 0.82s cubic-bezier(.7,.3,.1,.1) both;
  transform: translate3d(0, 0, 0);
}
@keyframes shakeX {
  10%, 90% {
    transform: translate3d(-5px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(5px, 0px, 0px);
  }
  30%, 50%, 70% {
    transform: translate3d(-5px, 0px, 0);
  }
  40%, 60% {
    transform: translate3d(10px, 0px, 0);
  }
}
@keyframes shaked4 {
  10%, 90% {
    transform: translate3d(-1px, -1px, 0);
  }
  20%, 80% {
    transform: translate3d(3px, 3px, 0px);
  }
  30%, 50%, 70% {
    transform: translate3d(-5px, 5px, 0);
  }
  40%, 60% {
    transform: translate3d(1px, -1px, 0);
  }
}
@keyframes shaked6 {
  10%, 90% {
    transform: translate3d(-3px, 3px, 0);
  }
  20%, 80% {
    transform: translate3d(5px, -5px, 0px);
  }
  30%, 50%, 70% {
    transform: translate3d(-5px, 5px, 0);
  }
  40%, 60% {
    transform: translate3d(5px, 0px, 0);
  }
}
@keyframes shaked8 {
  10%, 90% {
    transform: translate3d(5px, -5px, 0px);
  }
  20%, 80% {
    transform: translate3d(-3px, 3px, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(7px, -7px, 0);
    }
  40%, 60% {
    transform: translate3d(-5px, 5px, 0);
  }
}
@keyframes shaked10 {
  10%, 90% {
    transform: translate3d(-10px, -4px, 0);
  }
  20%, 80% {
    transform: translate3d(6px, 8px, 0px);
  }
  30%, 50%, 70% {
    transform: translate3d(-5px, -6px, 0);
  }
  40%, 60% {
    transform: translate3d(1px, 5px, 0);
  }
}
</style>